import {
  LABELS,
  DISPLAY_NAME,
  EMAIL,
  TYPE,
  COMPANY_NAME,
  STATUS,
  DEACTIVATED_REASON,
  AUTHED_AT,
  MEMO,
  COMMENT,
} from "./constants";

export const columnDefinitionsBase = [
  {
    id: DISPLAY_NAME,
    header: LABELS.COMMON.DISPLAY_NAME,
  },
  {
    id: EMAIL,
    header: LABELS.COMMON.EMAIL,
  },
  {
    id: TYPE,
    header: LABELS.COMMON.TYPE,
  },
  {
    id: COMPANY_NAME,
    header: LABELS.COMMON.COMPANY_NAME,
  },
  {
    id: STATUS,
    header: LABELS.COMMON.STATUS,
  },
  {
    id: DEACTIVATED_REASON,
    header: LABELS.TABLE.DEACTIVATED_REASON,
  },
  {
    id: AUTHED_AT,
    header: LABELS.COMMON.AUTHED_AT,
  },
  {
    id: MEMO,
    header: LABELS.COMMON.MEMO,
  },
  {
    id: COMMENT,
    header: LABELS.COMMON.COMMENT,
  },
];

/**
 * 権限に応じたテーブル定義を取得する
 *
 * @param {boolean} isDocomoUser ドコモユーザか
 * @returns テーブル定義
 */
export const getColumnDefinitions = (isDocomoUser: boolean) => {
  if (!isDocomoUser) {
    return columnDefinitionsBase.filter(
      (item) => ![TYPE, COMPANY_NAME, COMMENT].includes(item.id)
    );
  }

  return columnDefinitionsBase;
};
